export enum JourneyNodeType {
  // No-Op node type. Meant only for testing.
  NoOp = "no-op",

  EntryEvent = "entry-event",
  EntryCohort = "entry-cohort",
  EntryAudienceExperiment = "entry-audience-experiment",
  WaitUntilEvent = "wait-until-event",
  TimeDelay = "time-delay",
  Segments = "segments",
  Splits = "splits",
  Sync = "sync",
  // Realtime only. Calls a Function and holds the user until its response comes back.
  Function = "function",
  Context = "context",
  CouponAssignment = "coupon-assignment",
  Message = "message",
  Decision = "decision",

  // Branch nodes
  SegmentBranch = "segment-branch",
  WaitUntilEventBranch = "wait-until-event-branch",
  SplitBranch = "split-branch",
  EntryAudienceExperimentBranch = "entry-audience-experiment-branch",
}

export enum JourneyNodeSyncMode {
  Cohort = "cohort",
  Trigger = "trigger",
  Message = "message",
}

export const SYNC_TIMEOUT_ACTIONS = ["continue", "exit"] as const;
export type JourneySyncTimeoutAction = (typeof SYNC_TIMEOUT_ACTIONS)[number];
export const DEFAULT_SYNC_TIMEOUT_ACTION: JourneySyncTimeoutAction = "continue";
